import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'xemex-support-page',
  imports: [],
  templateUrl: './support-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './support-page.component.scss',
})
export class SupportPageComponent {}
